<!-- modal payment embed https://app.sandbox.midtrans.com/snap/v4/redirection/44a33193-f7a1-4915-9878-2f0bdd0f94b2#/407 -->
<template>
	<ModalComponent class="mt-8" ref="modalRef" :isHeader="false" :isFooter="false" :is-background-transparent="true"
		:close-on-background-click="false">

		<div class="button-close cursor-pointer" @click="closeGopayPaymentPage()">
			<IconButtonClose width_prop="2rem" height_prop="2rem" color_prop="#FFFFFF" />
		</div>

		<div v-if="url == ''" class="iframe flex justify-center items-center bg-grey-1">
			<Loader size_prop="10em"></Loader>
		</div>

		<div v-else class="wrap-iframe">
			<iframe ref="myFrame" :src="url" class="" sandbox="allow-scripts allow-forms allow-same-origin">
			</iframe>

			<div v-if="!isOnline" class="overlay-button bg-grey-1 text-white">
				<div class="mb-3">No Internet Connection</div>
				<button v-if="!isLoadingRefresh" class="btn bg-theme" @click="refreshIframe">Reconnect</button>
				<Loader v-else size_prop="4em"></Loader>
			</div>
		</div>

	</ModalComponent>
</template>

<script>
import ModalComponent from './ModalComponent.vue'
import { getHealthCheck } from '../api/health-check'

import Loader from './Loader.vue'
import IconButtonClose from './icons/IconButtonClose.vue'

import Alert from './alert-component/AlertComponent'

export default {
	name: 'GopayPaymentPage',

	components: {
		ModalComponent,
		Loader,
		IconButtonClose
	},

	data() {
		return {
			url: "",
			isOnline: navigator.onLine,

			intervalIdHealthCheck: null,
			isLoadingRefresh: false,
		}
	},

	computed: {
		isModalOpen() {
			if (this.$refs.modalRef) {
				return this.$refs.modalRef.isOpen
			} else {
				return false
			}
		}
	},

	mounted() {
		window.addEventListener("message", this.handleMessage)

		this.intervalIdHealthCheck = setInterval(() => {
			if (this.isModalOpen) {
				this.healthCheck()
			}
		}, 5000) // check every 5 s
	},

	beforeDestroy() {
		window.removeEventListener("message", this.handleMessage)

		clearInterval(this.intervalId)
	},

	methods: {
		openGopayPaymentPage(urlValue) {
			this.$refs.modalRef.openModal()

			this.url = urlValue
			// this.url = "http://localhost:8080/#/redirect/?fromData=gopay&toData=transaction"
		},

		closeGopayPaymentPage() {
			Alert.open({
				type: 'confirm',
				title: 'Apakah Anda yakin ingin membatalkan order?',
				showIcon: false,
				description: 'Jika Anda membatalkan proses ini, order tidak dapat dilanjutkan. <br> Catatan: Status order mungkin masih tertulis Waiting for Payment dan akan diperbarui secara otomatis setelah beberapa saat.',
				buttonConfirmText: 'Ya, Batalkan Order',
				buttonDeclineText: 'Batal',
				onConfirm: () => {
					this.$emit('goToTradeTicket')
					this.$refs.modalRef.closeModal()
				},
			})
		},

		handleMessage(event) {
			const origin = window.location.origin

			if (event.origin !== origin) return
			if (event.data.message === "goToTransaction") {
				this.$store.commit('setReportToShow_mut', 'transactions')
				this.$router.push({ name: 'Reports' })
			} else if (event.data.message === "goToTradeTicket") {
				this.$emit('goToTradeTicket')
				this.$refs.modalRef.closeModal()
			}
		},

		updateStatus() {
			this.isOnline = navigator.onLine
		},
		refreshIframe() {
			this.isLoadingRefresh = true
			setTimeout(() => {
				this.isLoadingRefresh = false
			}, 3000)

			const iframe = this.$refs.myFrame
			iframe.src = iframe.src
		},

		async healthCheck() {
			try {
				const response = await getHealthCheck()

				this.isOnline = response.status >= 200 && response.status < 400
			} catch (err) {
				this.isOnline = !this.isOfflineError(err)
				if (!this.isOnline) console.warn("Offline or unreachable:", err.message)

			}
		},

		isOfflineError(err) {
			if (!err) return false
			if (!navigator.onLine) return true
			if (/Network Error/i.test(err.message)) return true
			if (err.code === "ECONNABORTED") return true // timeout
			return false
		}
	}
}
</script>

<style scoped>
.wrap-iframe {
	width: 35rem;
	height: 50rem;
	overflow: hidden;
}

iframe,
.iframe {
	width: 76.92% !important;
	height: 76.92% !important;
	-webkit-transform: scale(1.3);
	transform: scale(1.3);
	-webkit-transform-origin: 0 0;
	transform-origin: 0 0;
}

.button-close {
	position: absolute;
	transform: translateY(-110%);
	right: 0;
}

.overlay-button {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>